export const metrics = [
  {
    title: "Average Total Allowable(ATA):",
    description:
      "Higher values indicate greater revenue potential per case, making payers more attractive.",
  },
  {
    title: "Average Patient Portion Percent(APPP): ",
    description:
      "A lower percentage means less financial burden on patients, reducing collection risk and making the payer more favorable.",
  },
  {
    title: "Average Patient Conversion Rate(APCR):",
    description:
      "Higher rates indicate a greater likelihood of collecting the patient portion, improving revenue realization.",
  },
  {
    title: "Scoring Formula through weighting:",
    description:
      "we have assigned weights to each metric based on their importance:",
    items: [
      {
        title: "ATA",
        description:
          "50% (revenue potential is critical for financial performance).",
      },
      {
        title: "APPP:",
        description:
          "25% (lower patient balance reduces risk but is slightly less critical than revenue).",
      },
      {
        title: "APCR:",
        description:
          "25% (collection success is important but secondary to revenue potential).",
      },
    ],
  },
];
